import React, { Component } from 'react';
import { Card, CardTitle, CardActions } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyDateString } from 'helpers/Formatter';

import { FaTags as PromotionsIcon } from 'react-icons/fa';

class PromotionInfo extends Component {
  render() {
    const style = {
      card: {
        color: '#424242 !important',
        fontFamily: '"Circular", sans-serif !important',
        overflow: 'hidden',
        marginTop: '15px',
      },
    };

    const promotion = this.props.promotion;
    return (
      <Card style={style.card} className="card" initiallyExpanded={true}>
        {promotion.image && (
          <img style={{ width: '100%' }} src={promotion.image} alt={promotion.name} />
        )}
        {!promotion.image && <PromotionsIcon size={250} color={AccentColor()} />}
        <div
          style={{
            bottom: '1px',
            left: '1px',
            right: '1px',
            background: 'white',
            borderRadius: '8px',
          }}
        >
          <CardTitle
            title={promotion.name}
            subtitle={
              <div>
                <div>
                  {promotion.expiration_date && (
                    <div>
                      {this.props.translate('expiryDate')}:{' '}
                      {toFriendlyDateString(promotion.expiration_date, {
                        language: this.props.currentLanguage,
                      })}
                    </div>
                  )}
                </div>
                <div>
                  {promotion.vendor && (
                    <div>
                      {this.props.translate('promotions.providedBy')}: {promotion.vendor}
                    </div>
                  )}
                </div>
                <div>
                  {promotion.vendor && promotion.link && (
                    <a href={promotion.link} target={'_blank'} rel="noopener noreferrer">
                      {' '}
                      {this.props.translate('clickForMoreDetails')}{' '}
                    </a>
                  )}
                </div>
              </div>
            }
            style={{ padding: '15px' }}
            titleStyle={{ fontFamily: 'Circular-Black' }}
          />

          <CardActions style={{ textAlign: 'center', padding: '0 15px 15px' }}>
            <FlatButton
              id={'open-promotion-dialog-button'}
              label={this.props.translate('view')}
              onClick={() => this.props.openPromotionDialog(promotion)}
              primary={true}
              disabled={this.props.disableViewButton || false}
              backgroundColor={this.props.disableViewButton ? colors.DARK_GRAY : AccentColor()}
              hoverColor="grey"
              fullWidth
              style={{
                color: 'white',
                height: '40px',
                margin: 'auto',
              }}
            />
          </CardActions>
        </div>
      </Card>
    );
  }
}

PromotionInfo = connect((state) => ({
  currentLanguage: state.locale.currentLanguage,
}))(PromotionInfo);

export default localize()(PromotionInfo);
